module.exports = __webpack_public_path__ + "static/media/1.7515e0f1.jpg";